import { render, staticRenderFns } from "./extra.vue?vue&type=template&id=14f4d2e7&scoped=true"
import script from "./extra.vue?vue&type=script&lang=js"
export * from "./extra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f4d2e7",
  null
  
)

export default component.exports